/* eslint-disable no-unused-vars */
import RequestMapping from '../request-mapping';
import { getRequest, postRequest } from '../../utils/saga-utils';

// Mock Data Imports
import { getTranslationsBasedOnLanguageCode } from '../mock/misc';
import { getFromSessionStorage } from '../../utils/session-storage-utils';
import { AUTH_TOKEN, JWT_TOKEN } from '../../constants/session-storage-keys';

function* fetchTranslationsApi(languageCode) {
  return yield getTranslationsBasedOnLanguageCode(languageCode);
}

function* fetchUserApi(queryParams = {}) {
  const url = RequestMapping.fetchUser;
  return yield getRequest(url, queryParams);
}

function* fetchUserAccessTagsApi(queryParams = {}) {
  const url = RequestMapping.fetchUserAccessTags;
  return yield getRequest(url, queryParams);
}

function* requestAppSignOutApi() {
  const url = RequestMapping.requestSignOut;
  return yield postRequest(url);
}

function* fetchEsignCreditsApi() {
  const url = RequestMapping.fetchEsignCredits;
  return yield getRequest(url);
}

function* fetchFeatureConfigApi() {
  const url = RequestMapping.fetchFeatureConfig;
  return yield getRequest(url);
}

function* fetchUserImpersonatorsApi() {
  const url = RequestMapping.fetchUserImpersonators;
  return yield getRequest(url);
}

function* validateAuthTokenApi() {
  const url = RequestMapping.validateAuthToken;
  return yield getRequest(url);
}

function* fetchLoginAccessTagsApi(queryParams = {}) {
  const url = RequestMapping.fetchLoginAccessTags;
  return yield getRequest(url, queryParams);
}

function* fetchJWTTokenApi() {
  const url = RequestMapping.fetchJWTToken;
  return yield postRequest(url, { token: getFromSessionStorage(AUTH_TOKEN) });
}

function* fetchEntitlementsApi() {
  const url = RequestMapping.fetchAuthProfile;
  const customHeaders = { Authorization: getFromSessionStorage(JWT_TOKEN) };
  return yield getRequest(url, { isRolesRequired: true }, {}, customHeaders);
}

function* fetchWorkflowBuilderConfigApi() {
  const url = RequestMapping.fetchWorkflowBuilderConfig;
  return yield getRequest(url);
}

export {
  fetchUserApi,
  fetchJWTTokenApi,
  fetchEntitlementsApi,
  fetchEsignCreditsApi,
  fetchTranslationsApi,
  requestAppSignOutApi,
  validateAuthTokenApi,
  fetchFeatureConfigApi,
  fetchUserAccessTagsApi,
  fetchLoginAccessTagsApi,
  fetchUserImpersonatorsApi,
  fetchWorkflowBuilderConfigApi,
};
